//  ----------      START   IMPORT  BLOCK       ----------
//  API
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
//  Types
import type { AuthorizedTranslatedUser, UserWhitelistResponse } from '../../Types/schema-helpers';
//  ----------      END   IMPORT  BLOCK       ----------

export interface UpdateAssistantsPayload {
  whitelist: string[];
}

class MedicAssistantService extends APIService {
  /**
   * Fetches the current doctor's list of assigned assistants.
   */
  async fetchAssistants(): Promise<UserWhitelistResponse> {
    return this.get<UserWhitelistResponse>(API_ROUTES.read_assistants);
  }

  /**
   * Updates the doctor's assigned assistants list in bulk.
   */
  async updateAssistants(dataToSend: AuthorizedTranslatedUser[]): Promise<boolean> {
    const payload: UpdateAssistantsPayload = {
      whitelist: dataToSend.map((user) => user.username),
    };
    return this.put<boolean, UpdateAssistantsPayload>(API_ROUTES.update_assistants, payload);
  }

  /**
   * Searches for a user across the network by username.
   */
  async searchAssistant(query: string): Promise<string | null> {
    return this.get<string | null>(API_ROUTES.search_user_whitelist(query));
  }
}

export default new MedicAssistantService();
